/* Page to fetch the 2nd unit Shooting Schedule Days data and all 
   Schedule Scenes
 * Contains DayTop2 component to which it passes the
   Day's cover info and the Schedule Scenes
 * Contains the link to the DayCreateForm component
 */
import React, { useEffect, useRef, useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import NoResults from "../../assets/no-results.png";
import Asset from "../../components/Asset";
import TopBox from "../../components/TopBox";
import DayTop2 from "./day2/DayTop2";
import Info2 from "./Info2";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import { toast } from "react-hot-toast";

import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";
import appStyles from "../../App.module.css";
import "react-calendar/dist/Calendar.css";

const SchedulePages2 = () => {
  const host = useHostName();
  const currentUser = useCurrentUser();
  const isMountedRef = useRef(false);
  const latestFetchIdRef = useRef(0);
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const [days, setDays] = useState({ results: [] });
  const [daysScenes, setDaysScenes] = useState({ results: [] });
  // eslint-disable-next-line
  const [error, setError] = useState({});
  const [hasLoaded, setHasLoaded] = useState(false);
  const [query, setQuery] = useState("");
  const filter = "";
  const message = "No Days Added";
  const history = useHistory();
  const [showInfo, setShowInfo] = useState(false);

  const buildSecondUnitDaysUrl = () => {
    const qs = new URLSearchParams();
    qs.set("is_second_unit", "true");
    if (filter) {
      const extra = new URLSearchParams(filter.replace(/^[&?]/, ""));
      extra.forEach((value, key) => {
        if (key) qs.append(key, value);
      });
    }
    if (query) qs.set("search", query);
    if (epi) qs.set("episode_ids", epi);
    return `days/?${qs.toString()}`;
  };

  const fetchDays = async (fetchId = latestFetchIdRef.current) => {
      /* Fetch all Days and all schedule scenes */
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [daysRes, { data: scenesData }] = await Promise.all([
            axiosReq.get(buildSecondUnitDaysUrl()),
            axiosReq.get(`schedule/scenes/?is_second_unit=true`),
          ]);
          if (daysRes?.success === false || daysRes?.status === false) {
            throw daysRes?.error || new Error("Failed to fetch days");
          }
          const { data: daysData } = daysRes;
          if (!isMountedRef.current || fetchId !== latestFetchIdRef.current) {
            return;
          }
          setDays(daysData);
          setDaysScenes(scenesData);
          setHasLoaded(true);
        } else {
          const [daysRes, { data: scenesData }] = await Promise.all([
            axiosInstance.get(
              // if epi is present, add it to the query string
              `${localStorage.getItem("projectSlug")}/${buildSecondUnitDaysUrl()}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
              )}/schedule/scenes/?is_second_unit=true`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
          ]);
          if (daysRes?.success === false || daysRes?.status === false) {
            throw daysRes?.error || new Error("Failed to fetch days");
          }
          const { data: daysData } = daysRes;
          if (!isMountedRef.current || fetchId !== latestFetchIdRef.current) {
            return;
          }
          setDays(daysData);
          setDaysScenes(scenesData);
          setHasLoaded(true);
        }
      } catch (err) {
        if (!isMountedRef.current || fetchId !== latestFetchIdRef.current) {
          return;
        }
        setError(err);
        console.log(err);
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.response?.data?.detail ||
            err?.message ||
            "Failed to load days."
        );
      }
    };

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    setHasLoaded(false);
    latestFetchIdRef.current += 1;
    const fetchId = latestFetchIdRef.current;

    const timer = setTimeout(() => {
      fetchDays(fetchId);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line
  }, [query, filter]);

  return (
    <div>
      <TopBox 
      second="2ND UNIT"
      title="Schedule"
      episodeTitle={`Episode ${episodeTitle}`} />
      {/* back info */}
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-1`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      <h5 className={`text-center py-1 mb-3 mt-1 ${styles.SubTitle}`}>
         2ND UNIT - SHOOT DAYS
      </h5>
      {!showInfo ? "" : <Info2 />}
      {/* add day */}
      <Row className="mt-3 mb-2">
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
              <Button
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem("projectSlug")}/days2unit/create${
                      epi && project && episodeTitle
                        ? `?episodeid=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                        : ""
                    }`
                  )
                }
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
              >
                Create Day
              </Button>
            )}
        </Col>
      </Row>
      <div>
        {/* search */}
        <Row>
          <Col
            className="mt-3"
            xs={{ span: 10, offset: 1 }}
            md={{ span: 6, offset: 3 }}
          >
            <Form
              onSubmit={(event) => event.preventDefault()}
            >
              <Form.Control
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                type="text"
                className={`${styles.InputBar}`}
                placeholder="Search by Day Number"
              />
            </Form>
          </Col>
        </Row>
        {/* days */}
        <Row className="mt-2 mb-5">
          {hasLoaded ? (
            <>
              {days?.results?.length ? (
                days?.results?.map((day) => (
                  <Col
                    key={day.id}
                    xs={{ span: 10, offset: 1 }}
                    sm={{ span: 6, offset: 0 }}
                    lg={4}
                    className="py-2"
                  >
                    <DayTop2
                      daysScenes={daysScenes}
                      {...day}
                      setDays={setDays}
                      epi={epi}
                      project={project}
                      episodeTitle={episodeTitle}
                      fetchDays={fetchDays}
                    />
                  </Col>
                ))
              ) : (
                <Container className={appStyles.Content}>
                  {query ? (
                    <Asset src={NoResults}
                    message="No Results"
                  />) : (
                  <Asset src={NoResults}
                  message={message}
                  />) } 
                </Container>
              )}
            </>
          ) : (
            <Container className={appStyles.Content}>
              <Asset spinner />
            </Container>
          )}
        </Row>
      </div>
    </div>
  );
};

export default SchedulePages2;
